import { createFileRoute, redirect } from "@tanstack/react-router";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/sms/")({
	beforeLoad: async ({ context, location }) => {
		// Guard jak strona docelowa — /sms to tylko przekierowanie na kampanie.
		await ensureElementVisible(context.queryClient, "sidebar.sms.kampanie", location.pathname);
		throw redirect({ to: "/sms/kampanie" });
	},
});
